import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';
import { appConfig } from '@repo/ui/src/utils/appConfig';

const OrangeCheckIcon = ({ ...rest }: IconWrapperProps) => (
  <IconWrapper width="24" height="24" viewBox="0 0 24 24" title="Orange Check" {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.8031 6.81776L18.2173 8.23197L11.1463 15.303L9.73204 16.7173L8.31783 15.303L4.7823 11.7675L6.19651 10.3533L9.73204 13.8888L16.8031 6.81776Z"
      fill={appConfig?.isTraeger ? '#D95E16' : '#C70F2E'}
    />
  </IconWrapper>
);

export default OrangeCheckIcon;
